import get from 'lodash/get';

export function getVisitFormOptions(list, valueKey = 'id', labelKey = 'name') {
  return list.map(item => {
    return {
      label: get(item, labelKey),
      value: get(item, valueKey),
    };
  });
}

export function getSelectableList(list, id, key) {
  const selectedItem = list.find(item => item.id === id);
  return get(selectedItem, key, []);
}



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/utils/getVisitFormData.js